import { get } from 'lodash';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import { GLOBAL_STATUS } from 'services/constants';
import { FeeNoteType } from 'typings/globalTypes';

export const getPendingFeeNotesByNoticeId = (
  feeNotes: FeeNoteType[],
  missionPostPoneId: number,
) => {
  return feeNotes.filter(
    (el: FeeNoteType) =>
      get(el.feeNoteMission, 'missionPostPoneId') === missionPostPoneId &&
      (el.status === GLOBAL_STATUS.PENDING ||
        el.status === GLOBAL_STATUS.REJECTED) &&
      el.codeIntervenant === currentIntervenantStorage?.get()?.sagis_code,
  );
};
